import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import * as React from "react";

interface BoundaryImpactWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const BoundaryImpactWarningModal: React.FC<
  BoundaryImpactWarningModalProps
> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="2xl" fontWeight="semibold" color="gray.900">
          Save changes?
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="gray.700" lineHeight="tall">
              Saving these changes may impact existing forms and their
              responses. Forms using school selection and boundary eligibility
              may be impacted, causing previous responses to become eligible or
              viceversa.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3} w="full" justify="flex-end">
            <Button
              variant="ghost"
              onClick={onClose}
              isDisabled={isLoading}
              color="primary.600"
              fontSize="md"
              fontWeight="medium"
            >
              Cancel
            </Button>
            <Button
              colorScheme="primary"
              onClick={onConfirm}
              isLoading={isLoading}
              px={8}
            >
              Yes, save changes
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
